import { render, staticRenderFns } from "./RefProductListAddNew.vue?vue&type=template&id=0f4edf8c"
import script from "./RefProductListAddNew.vue?vue&type=script&lang=js"
export * from "./RefProductListAddNew.vue?vue&type=script&lang=js"
import style0 from "./RefProductListAddNew.vue?vue&type=style&index=0&id=0f4edf8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports